import partnerService from '../service/partner'
const state = {
    partners: [],
    customers:[],
    loading: false
}

const actions = {
    updatePartner({ commit }, form) {
        return partnerService.updatePartner(form).then(() => {
            commit('updatePartner', form);
        })
    },
    createPartner({ commit }, partner) {
        return partnerService.createPartner(partner).then(data => {
            partner._id = data.partner._id;
            commit('addPartner', partner);
            return data;
        })
    },
    getCustomers({ commit },params) {
        return partnerService.getCustomers(params).then(customers => {
            commit('setCustomers', customers);
        }).catch(() => {
        })
    },
    getPartners({ commit }) {
        commit('setLoading', true)
        return partnerService.getPartners().then(partners => {
            commit('setPartners', partners);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    updatePartner(state,form) {
        let index = state.partners.findIndex(x=>x._id == form.id)
        if(index != -1){
            state.partners[index].name = form.name
            state.partners[index].address = form.address
            state.partners[index].email= form.email
            state.partners[index].mobileUserLimit = form.mobileUserLimit
            state.partners[index].phone = form.phone
            state.partners[index].logo = form.logo
        }
    },
    addPartner(state, partner) {
        state.partners.push(partner)
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setPartners(state, partners) {
        state.partners = partners
        state.loading = false
    },
    setCustomers(state,customers) {
        state.customers= customers
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



